<div class="flex flex-col gap-1">
  <!-- EMAIL -->
  <label for="guest-email" class="text-gray-500 text-sm font-medium leading-5 mt-2 mb-1 w-full"
    >Email <span class="text-red-700">*</span></label
  >
  <div class="relative w-full">
    <input
      id="guest-email"
      class="mib-input w-full"
      [class.mib-field-error]="guestForm.email().touched() && guestForm.email().invalid()"
      [formField]="guestForm.email"
      type="email"
      autocomplete="email"
    />
    @if (guestForm.email().touched() && guestForm.email().invalid()) {
      @for (error of guestForm.email().errors(); track error) {
        <div class="text-input-error text-xs mt-1">{{ error.message }}</div>
      }
    }
  </div>

  <!-- LASTNAME -->
  <label for="guest-lastname" class="text-gray-500 text-sm font-medium leading-5 mt-4 mb-1 w-full"
    >Full name <span class="text-red-700">*</span></label
  >
  <div class="relative w-full">
    <input
      id="guest-lastname"
      type="text"
      class="mib-input w-full"
      autocomplete="name"
      [class.mib-field-error]="guestForm.fullName().touched() && guestForm.fullName().invalid()"
      [formField]="guestForm.fullName"
    />
    @if (guestForm.fullName().touched() && guestForm.fullName().invalid()) {
      @for (error of guestForm.fullName().errors(); track error) {
        <div class="text-input-error text-xs mt-1">{{ error.message }}</div>
      }
    }
  </div>
</div>
